// Turkish locale helpers
export const fmtTRY = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
};

// KPI kartlarında ana tam sayı vurgusu + hafif kuruş gösterimi için
// para tutarını parçalara ayırır.  Örn. -₺69.456,01 → { integer: "-₺69.456", decimal: ",01" }
// Sembol, negatif işaret ve binlik ayraçları ``fmtTRY`` ile bire bir aynı locale çıktısı
// üzerinden alınır → tek kaynak.
export const fmtTRYParts = (n) => {
  const full = fmtTRY(n);
  // tr-TR biçiminde ondalık ayraç virgüldür ("₺1.234,56").
  const idx = full.lastIndexOf(",");
  if (idx < 0) return { integer: full, decimal: "" };
  return { integer: full.slice(0, idx), decimal: full.slice(idx) };
};

export const fmtNumber = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return iso;
  return `${d}.${m}.${y}`;
};

// "2026-08-19T09:14:23.451Z" → "19.08.2026 09:14"
// Sadece backend UTC ISO string'lerini kullanıcı dostu tarih+saat biçimine
// çevirir; timezone / mevcut ``fmtDate`` davranışı değişmez.
export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const dt = new Date(iso);
  if (isNaN(dt.getTime())) return String(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(dt.getDate())}.${pad(dt.getMonth() + 1)}.${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const PAYMENT_STATUS_LABEL = {
  pending: "Beklemede",
  partial: "Kısmi Ödendi",
  paid: "Ödendi",
};

export const INVOICE_STATUS_LABEL = {
  invoiced: "Faturalı",
  non_invoiced: "Faturasız",
};

export const CASH_ACCOUNT_LABEL = {
  company: "Şirket Kasası",
  personal: "Şahsi Kasa",
};

export const JOB_STATUS_LABEL = {
  active: "Aktif",
  completed: "Tamamlandı",
  pending: "Beklemede",
  cancelled: "İptal",
};

export const CUSTOMER_STATUS_LABEL = {
  active: "Aktif",
  passive: "Pasif",
};

export const PAYMENT_METHOD_LABEL = {
  cash: "Nakit",
  bank_transfer: "Banka Havalesi",
  credit_card: "Kredi Kartı",
  check: "Çek",
  other: "Diğer",
};
